var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a4c7;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.61,19.85l9.39-5.89V0H10v13.97l9.39,5.89C8.23,22.78,0,32.93,0,45,0,59.36,11.64,71,26,71s26-11.64,26-26c0-12.07-8.23-22.22-19.39-25.15ZM42.72,41.6l-6.52,6.35c-.39.38-.57.94-.48,1.48l1.54,8.97c.23,1.37-1.2,2.41-2.43,1.76l-8.05-4.23c-.49-.26-1.07-.26-1.56,0l-8.05,4.23c-1.23.65-2.66-.4-2.43-1.76l1.54-8.97c.09-.54-.09-1.1-.48-1.48l-6.52-6.35c-.99-.97-.45-2.65.93-2.85l9.01-1.31c.55-.08,1.02-.42,1.26-.92l4.03-8.16c.61-1.24,2.39-1.24,3,0l4.03,8.16c.24.49.71.84,1.26.92l9.01,1.31c1.37.2,1.92,1.89.93,2.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedal);
export default __webpack_public_path__ + "static/media/Icon-Medal.362083858bf542e80c998c6114e29abe.svg";
export { ForwardRef as ReactComponent };